export default __webpack_public_path__ + "static/6-38d9b04ade9f1399c205e7151b8907c6.png";